/**
 * article模块接口列表
 */
// import base from "../base"; // 导入接口域名列表
import axios from "@/request/http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const userInfo = {
  // post提交
  userInfo(params) {
    return axios.post(`/user/home/page`, qs.stringify(params));
  },
  // 获取短信验证码
  getVCode(params) {
    return axios.post(`/user/h5/reqSmsVerifyCode`, params);
  },
  payTip: params => {
    return axios.post('/cc/pay/tip', params)
  },
  storeIndex: params => {
    return axios.post('/sku-api/index/store-index', params)
  },
};

export default userInfo;
